import { ObjectType, SignType, AspectType } from "@chronos/astro-lib";
import * as objects from './assets/astro/objects';
import * as signs from './assets/astro/signs';
import * as aspects from './assets/astro/aspects';
export const objectsIcons = {
    [ObjectType.Sun]: objects.SunIcon,
    [ObjectType.Moon]: objects.MoonIcon,
    [ObjectType.Mercury]: objects.MercuryIcon,
    [ObjectType.Venus]: objects.VenusIcon,
    [ObjectType.Mars]: objects.MarsIcon,
    [ObjectType.Jupiter]: objects.JupiterIcon,
    [ObjectType.Saturn]: objects.SaturnIcon,
    [ObjectType.Uranus]: objects.UranusIcon,
    [ObjectType.Neptune]: objects.NeptuneIcon,
    [ObjectType.Pluto]: objects.PlutoIcon,
    [ObjectType.NorthNode]: objects.NorthNodeIcon,
    [ObjectType.SouthNode]: objects.SouthNodeIcon,
    [ObjectType.Lilith]: objects.LilithIcon,
    [ObjectType.Chiron]: objects.ChironIcon,
    [ObjectType.Selena]: objects.SelenaIcon,
    [15]: objects.ErisIcon
};
export const objectNames = {
    [ObjectType.Sun]: { t: "chronos.auth.planets.sun.name", ru: "Солнце" },
    [ObjectType.Moon]: { t: "chronos.auth.planets.moon.name", ru: "Луна" },
    [ObjectType.Mercury]: { t: "chronos.auth.planets.mercury.name", ru: "Меркурий" },
    [ObjectType.Venus]: { t: "chronos.auth.planets.venus.name", ru: "Венера" },
    [ObjectType.Mars]: { t: "chronos.auth.planets.mars.name", ru: "Марс" },
    [ObjectType.Jupiter]: { t: "chronos.auth.planets.jupiter.name", ru: "Юпитер" },
    [ObjectType.Saturn]: { t: "chronos.auth.planets.saturn.name", ru: "Сатурн" },
    [ObjectType.Uranus]: { t: "chronos.auth.planets.uranus.name", ru: "Уран" },
    [ObjectType.Neptune]: { t: "chronos.auth.planets.neptune.name", ru: "Нептун" },
    [ObjectType.Pluto]: { t: "chronos.auth.planets.pluto.name", ru: "Плутон" },
    [ObjectType.NorthNode]: { t: "chronos.auth.planets.northNode.name", ru: "Северный Узел" },
    [ObjectType.SouthNode]: { t: "chronos.auth.planets.southNode.name", ru: "Южный узел" },
    [ObjectType.Lilith]: { t: "chronos.auth.planets.lilith.name", ru: "Лилит" },
    [ObjectType.Chiron]: { t: "chronos.auth.planets.chiron.name", ru: "Хирон" },
    [ObjectType.Selena]: { t: "chronos.auth.planets.selena.name", ru: "Селена" },
    [15]: { t: "chronos.auth.planets.eris.name", ru: "Эрида" }
};
export const signsIcons = {
    [SignType.Aries]: signs.AriesIcon,
    [SignType.Taurus]: signs.TaurusIcon,
    [SignType.Gemini]: signs.GeminiIcon,
    [SignType.Cancer]: signs.CancerIcon,
    [SignType.Leo]: signs.LeoIcon,
    [SignType.Virgo]: signs.VirgoIcon,
    [SignType.Libra]: signs.LibraIcon,
    [SignType.Scorpio]: signs.ScorpioIcon,
    [SignType.Sagittarius]: signs.SagittariusIcon,
    [SignType.Capricorn]: signs.CapricornIcon,
    [SignType.Aquarius]: signs.AquariusIcon,
    [SignType.Pisces]: signs.PiscesIcon
};
export const signsNames = {
    [SignType.Aries]: { t: "chronos.auth.planets.mars.sign", ru: "Овен" },
    [SignType.Taurus]: { t: "chronos.app.instruments.widgets.prompts.signs.taurus.name", ru: "Телец" },
    [SignType.Gemini]: { t: "chronos.app.instruments.widgets.prompts.signs.gemini.name", ru: "Близнецы" },
    [SignType.Cancer]: { t: "chronos.auth.planets.moon.sign", ru: "Рак" },
    [SignType.Leo]: { t: "chronos.auth.planets.sun.sign", ru: "Лев" },
    [SignType.Virgo]: { t: "chronos.app.instruments.widgets.prompts.signs.virgo.name", ru: "Дева" },
    [SignType.Libra]: { t: "chronos.app.instruments.widgets.prompts.signs.libra.name", ru: "Весы" },
    [SignType.Scorpio]: { t: "chronos.auth.planets.pluto.sign", ru: "Скорпион" },
    [SignType.Sagittarius]: { t: "chronos.auth.planets.jupiter.sign", ru: "Стрелец" },
    [SignType.Capricorn]: { t: "chronos.auth.planets.saturn.sign", ru: "Козерог" },
    [SignType.Aquarius]: { t: "chronos.auth.planets.uranus.sign", ru: "Водолей" },
    [SignType.Pisces]: { t: "chronos.auth.planets.neptune.sign", ru: "Рыбы" }
};
export const aspectsIcons = {
    [AspectType.Conjunction]: aspects.ConjunctionIcon,
    [AspectType.Semisextile]: aspects.SemisextileIcon,
    [AspectType.Semiquintile]: aspects.SemiquintileIcon,
    [AspectType.Novile]: aspects.NovileIcon,
    [AspectType.Semisquare]: aspects.SemisquareIcon,
    [AspectType.Sextile]: aspects.SextileIcon,
    [AspectType.Quintile]: aspects.QuintileIcon,
    [AspectType.Binovile]: aspects.BinovileIcon,
    [AspectType.Square]: aspects.SquareIcon,
    [AspectType.MinusOrPlus]: aspects.MinusOrPlusIcon,
    [AspectType.Tredecile]: aspects.TredecileIcon,
    [AspectType.Trine]: aspects.TrineIcon,
    [AspectType.Sesquiquadrate]: aspects.SesquiquadrateIcon,
    [AspectType.Biquintile]: aspects.BiquintileIcon,
    [AspectType.Quincunx]: aspects.QuincunxIcon,
    [AspectType.Opposition]: aspects.OppositionIcon
};
export const aspectNames = {
    [AspectType.Conjunction]: { t: "chronos.auth.planets.conjunction.name", ru: "Соединение" },
    [AspectType.Semisextile]: { t: "chronos.auth.planets.semisextile.name", ru: "Полусекстиль" },
    [AspectType.Semiquintile]: { t: "chronos.auth.planets.semiquintile.name", ru: "Полуквинтиль" },
    [AspectType.Novile]: { t: "chronos.auth.planets.novile.name", ru: "Нонвиль" },
    [AspectType.Semisquare]: { t: "chronos.auth.planets.semisquare.name", ru: "Полуквадрат" },
    [AspectType.Sextile]: { t: "chronos.auth.planets.sextile.name", ru: "Секстиль" },
    [AspectType.Quintile]: { t: "chronos..auth.planets.quintile.name", ru: "Квинтиль" },
    [AspectType.Binovile]: { t: "chronos.auth.planets.binovile.name", ru: "Биновиль" },
    [AspectType.Square]: { t: "chronos.auth.planets.square.name", ru: "Квадрат" },
    [AspectType.MinusOrPlus]: { t: "chronos.auth.planets.minusOrPlus.name", ru: "Минус или Плюс" },
    [AspectType.Tredecile]: { t: "chronos.auth.planets.tredecile.name", ru: "Тредециль" },
    [AspectType.Trine]: { t: "chronos.auth.planets.trine.name", ru: "Трин" },
    [AspectType.Sesquiquadrate]: { t: "chronos.auth.planets.sesquiquadrate.name", ru: "Сексуквадрат" },
    [AspectType.Biquintile]: { t: "chronos.auth.planets.biquintile.name", ru: "Биквинтиль" },
    [AspectType.Quincunx]: { t: "chronos.auth.planets.quincunx.name", ru: "Квинкункс" },
    [AspectType.Opposition]: { t: "chronos.auth.planets.opposition.name", ru: "Оппозиция" }
};
export const ObjectTypes = {
    Sun: 0,
    Moon: 1,
    Mercury: 2,
    Venus: 3,
    Mars: 4,
    Jupiter: 5,
    Saturn: 6,
    Uranus: 7,
    Neptune: 8,
    Pluto: 9,
    NorthNode: 10,
    SouthNode: 11,
    Lilith: 12,
    Chiron: 13,
    Selena: 14,
    Eris: 15
};
export var StatusType;
(function (StatusType) {
    StatusType[StatusType["ruler"] = 0] = "ruler";
    StatusType[StatusType["exaltation"] = 1] = "exaltation";
    StatusType[StatusType["triplicity"] = 2] = "triplicity";
    StatusType[StatusType["bounds"] = 3] = "bounds";
    StatusType[StatusType["face"] = 4] = "face";
    StatusType[StatusType["fall"] = 5] = "fall";
    StatusType[StatusType["detriment"] = 6] = "detriment";
})(StatusType || (StatusType = {}));
export const dispositors = {
    [SignType.Aries]: {
        [StatusType.ruler]: [ObjectType.Mars, ObjectType.Pluto],
        [StatusType.exaltation]: [ObjectType.Sun],
        [StatusType.triplicity]: [ObjectType.Jupiter, ObjectType.Neptune],
        [StatusType.bounds]: [ObjectType.Moon],
        [StatusType.face]: [ObjectType.Mercury, ObjectType.Uranus],
        [StatusType.fall]: [ObjectType.Saturn],
        [StatusType.detriment]: [ObjectType.Venus]
    },
    [SignType.Taurus]: {
        [StatusType.ruler]: [ObjectType.Venus],
        [StatusType.exaltation]: [ObjectType.Moon],
        [StatusType.triplicity]: [ObjectType.Saturn, ObjectType.Mercury],
        [StatusType.bounds]: [ObjectType.Sun],
        [StatusType.face]: [ObjectType.Jupiter, ObjectType.Neptune],
        [StatusType.fall]: [ObjectType.Uranus],
        [StatusType.detriment]: [ObjectType.Mars, ObjectType.Pluto]
    },
    [SignType.Gemini]: {
        [StatusType.ruler]: [ObjectType.Mercury],
        [StatusType.exaltation]: [ObjectType.Mercury],
        [StatusType.triplicity]: [ObjectType.Venus, ObjectType.Saturn, ObjectType.Uranus],
        [StatusType.bounds]: [ObjectType.Moon],
        [StatusType.face]: [ObjectType.Sun, ObjectType.Mars, ObjectType.Pluto],
        [StatusType.fall]: [null],
        [StatusType.detriment]: [ObjectType.Jupiter, ObjectType.Neptune]
    },
    [SignType.Cancer]: {
        [StatusType.ruler]: [ObjectType.Moon],
        [StatusType.exaltation]: [ObjectType.Jupiter],
        [StatusType.triplicity]: [ObjectType.Pluto, ObjectType.Neptune],
        [StatusType.bounds]: [ObjectType.Sun],
        [StatusType.face]: [ObjectType.Mercury, ObjectType.Venus],
        [StatusType.fall]: [ObjectType.Mars],
        [StatusType.detriment]: [ObjectType.Saturn, ObjectType.Uranus]
    },
    [SignType.Leo]: {
        [StatusType.ruler]: [ObjectType.Sun],
        [StatusType.exaltation]: [ObjectType.Pluto],
        [StatusType.triplicity]: [ObjectType.Jupiter, ObjectType.Mars],
        [StatusType.bounds]: [ObjectType.Moon],
        [StatusType.face]: [ObjectType.Mercury, ObjectType.Venus],
        [StatusType.fall]: [ObjectType.Neptune],
        [StatusType.detriment]: [ObjectType.Saturn, ObjectType.Uranus]
    },
    [SignType.Virgo]: {
        [StatusType.ruler]: [ObjectType.Mercury],
        [StatusType.exaltation]: [ObjectType.Mercury],
        [StatusType.triplicity]: [ObjectType.Saturn, ObjectType.Uranus],
        [StatusType.bounds]: [ObjectType.Sun],
        [StatusType.face]: [ObjectType.Moon, ObjectType.Mars, ObjectType.Pluto],
        [StatusType.fall]: [ObjectType.Venus],
        [StatusType.detriment]: [ObjectType.Jupiter, ObjectType.Neptune]
    },
    [SignType.Libra]: {
        [StatusType.ruler]: [ObjectType.Venus],
        [StatusType.exaltation]: [ObjectType.Saturn],
        [StatusType.triplicity]: [ObjectType.Mercury, ObjectType.Uranus],
        [StatusType.bounds]: [ObjectType.Moon],
        [StatusType.face]: [ObjectType.Jupiter, ObjectType.Neptune],
        [StatusType.fall]: [ObjectType.Sun],
        [StatusType.detriment]: [ObjectType.Mars, ObjectType.Pluto]
    },
    [SignType.Scorpio]: {
        [StatusType.ruler]: [ObjectType.Pluto, ObjectType.Mars],
        [StatusType.exaltation]: [ObjectType.Uranus],
        [StatusType.triplicity]: [ObjectType.Jupiter, ObjectType.Neptune],
        [StatusType.bounds]: [ObjectType.Sun],
        [StatusType.face]: [ObjectType.Saturn, ObjectType.Mercury],
        [StatusType.fall]: [ObjectType.Moon],
        [StatusType.detriment]: [ObjectType.Venus]
    },
    [SignType.Sagittarius]: {
        [StatusType.ruler]: [ObjectType.Jupiter, ObjectType.Neptune],
        [StatusType.exaltation]: [null],
        [StatusType.triplicity]: [ObjectType.Sun, ObjectType.Mars, ObjectType.Pluto],
        [StatusType.bounds]: [ObjectType.Moon],
        [StatusType.face]: [ObjectType.Venus, ObjectType.Saturn, ObjectType.Uranus],
        [StatusType.fall]: [ObjectType.Mercury],
        [StatusType.detriment]: [ObjectType.Mercury]
    },
    [SignType.Capricorn]: {
        [StatusType.ruler]: [ObjectType.Saturn, ObjectType.Uranus],
        [StatusType.exaltation]: [ObjectType.Mars],
        [StatusType.triplicity]: [ObjectType.Mercury, ObjectType.Venus],
        [StatusType.bounds]: [ObjectType.Sun],
        [StatusType.face]: [ObjectType.Pluto, ObjectType.Neptune],
        [StatusType.fall]: [ObjectType.Jupiter],
        [StatusType.detriment]: [ObjectType.Moon]
    },
    [SignType.Aquarius]: {
        [StatusType.ruler]: [ObjectType.Uranus, ObjectType.Saturn],
        [StatusType.exaltation]: [ObjectType.Neptune],
        [StatusType.triplicity]: [ObjectType.Mercury, ObjectType.Venus],
        [StatusType.bounds]: [ObjectType.Moon],
        [StatusType.face]: [ObjectType.Jupiter, ObjectType.Mars],
        [StatusType.fall]: [ObjectType.Pluto],
        [StatusType.detriment]: [ObjectType.Sun]
    },
    [SignType.Pisces]: {
        [StatusType.ruler]: [ObjectType.Neptune, ObjectType.Jupiter],
        [StatusType.exaltation]: [ObjectType.Venus],
        [StatusType.triplicity]: [ObjectType.Moon, ObjectType.Pluto, ObjectType.Mars],
        [StatusType.bounds]: [ObjectType.Sun],
        [StatusType.face]: [ObjectType.Saturn, ObjectType.Uranus],
        [StatusType.fall]: [ObjectType.Mercury],
        [StatusType.detriment]: [ObjectType.Mercury]
    }
};
export const initialStrongs = {
    planets: [],
    houses: {
        houses: [],
        planets: [],
        power: []
    },
    aspects: [],
    objects: [],
    objectsExt: [],
};
export const defaultForm = {
    "useNatalPlace": false,
    "avatarUrl": null,
    "housesSystem": {
        "horar": 2,
        "common": 0,
        "northern": 3
    },
    "apTest": null,
    "name": "Default map",
    "color": "#5E5E5E",
    "modified": "2025-04-04T10:08:02.755Z",
    "natal": {
        "name": "",
        "place": {
            "id": 518976,
            "lat": 56.11095,
            "lon": 47.47755,
            "name": "Новочебоксарск, Чувашия, Россия",
            "counter": 0,
            "language": "ru",
            "population": 128468,
            "originalLat": 56.11095,
            "originalLon": 47.47755,
            "originalName": "Новочебоксарск, Чувашия, Россия",
            "showUserCoordinates": false
        },
        "gender": "male",
        "dateTime": {
            "date": "19.03.1977",
            "time": "18:30:00",
            "autoGmt": false,
            "cosmogram": false
        },
        "dt": "1977-03-19T18:30:00.000Z",
        "autoGmt": false
    },
    "synastry": null,
    "prognostics": null,
    "syn_prognostics": null,
    "horar": null,
    "relocation": null,
    "partners": [],
    "rectification": null,
    "settings": {
        "modes": {
            "synastry": [
                "syn_natal"
            ],
            "relocation": [
                "relocation_natal"
            ],
            "prognostics": [
                "directions",
                "solars",
                "transits",
                "prog_natal"
            ]
        },
        "widgets": [
            {
                "id": "aspects-table",
                "order": 0,
                "isActive": false
            },
            {
                "id": "strong-objects",
                "order": 2,
                "isActive": false
            },
            {
                "id": "house-formulas",
                "order": 3,
                "isActive": false
            },
            {
                "id": "analyze",
                "order": 4,
                "isActive": false
            },
            {
                "id": "orbise-corrector",
                "order": 6,
                "isActive": false
            },
            {
                "id": "rectification",
                "order": 7,
                "isActive": false
            },
            {
                "id": "devplan",
                "order": 8,
                "isActive": false
            },
            {
                "id": "autoprediction",
                "order": 9,
                "isActive": false
            },
            {
                "id": "interpretation",
                "order": 10,
                "isActive": false
            },
            {
                "id": "coordinates-of-planets-and-houses",
                "order": 1,
                "isActive": false,
                "canUseFree": false
            },
            {
                "id": "dispositors",
                "order": 5,
                "isActive": false,
                "canUseFree": false
            },
            {
                "id": "horar-events",
                "order": 11,
                "isActive": false,
                "canUseFree": false
            },
            {
                "id": "formula-strength",
                "order": 12,
                "isActive": false,
                "canUseFree": false
            },
            {
                "id": "ephemeris-formulas",
                "order": 13,
                "isActive": false,
                "canUseFree": false
            },
            {
                "id": "formula-years",
                "order": 14,
                "isActive": false,
                "canUseFree": false
            },
            {
                "id": "horar-speed",
                "order": 15,
                "isActive": false,
                "canUseFree": false
            },
            {
                "id": "horar-essentials",
                "order": 16,
                "isActive": false,
                "canUseFree": false
            },
            {
                "id": "formula-soul",
                "order": 17,
                "isActive": false,
                "canUseFree": false
            },
            {
                "id": "interpretation-soul",
                "order": 18,
                "isActive": false,
                "canUseFree": false
            },
            {
                "id": "horar-analysis",
                "order": 19,
                "isActive": false,
                "canUseFree": false
            },
            {
                "id": "horar-light",
                "order": 20,
                "isActive": false,
                "canUseFree": false
            }
        ],
        "dfltModes": [
            "relocation_natal"
        ],
        "dfltSynastry": [],
        "dfltRelocation": [],
        "dfltPrognostics": []
    },
    "access": {
        "type": "private",
        "showPersonalData": true,
        "permissions": [
            "BASE"
        ],
        "isPersonal": true
    },
    "gen": {
        "devplan": false,
        "autoprediction": false,
        "rectification": false
    },
    "cosmogram": false,
    "isTemporary": false
};
export const defaultAstroSettings = {
    "id": 0,
    "mutable": false,
    "title": "chronos.app.instruments.widgets.schoolSelector.paa",
    "overSign": 70,
    "overSign0": 50,
    "housesSystem": {
        "horar": 2,
        "common": 0,
        "northern": 3
    },
    "idCustomization": 2,
    "isRounded": true,
    "northernLatitude": 61.75,
    "useNatalPlace": true,
    "showHigherPlanets": true,
    "startingPoint": "asc",
    "rotationDir": "ccw",
    "hideTransitAspects": true,
    "showMinorPlanets": true,
    "closureConfig": 1,
    "planetConnectionConfig": true,
    "widgets": {
        "dispositors": {
            "planets": [
                {
                    "id": "Chiron",
                    "label": "astro.chiron",
                    "isActive": false
                },
                {
                    "id": "Lilith",
                    "label": "astro.lilith",
                    "isActive": false
                },
                {
                    "id": "Nodes",
                    "label": "astro.nodes",
                    "isActive": false
                },
                {
                    "id": "Selena",
                    "label": "astro.selena",
                    "isActive": false
                },
                {
                    "id": "Eris",
                    "label": "astro.eris",
                    "isActive": false
                }
            ]
        }
    },
    "fixedStars": {
        "natal": {
            "list": [
                "Algol",
                "Aldebaran",
                "Antares",
                "Betelgeuse",
                "Regulus",
                "Sirius"
            ],
            "showWithObjects": true
        },
        "synastry": {
            "list": [
                "Algol",
                "Aldebaran",
                "Antares",
                "Betelgeuse",
                "Regulus",
                "Sirius"
            ],
            "showWithObjects": true
        },
        "prognostics": {
            "list": [
                "Algol",
                "Aldebaran",
                "Antares",
                "Betelgeuse",
                "Regulus",
                "Sirius"
            ],
            "showWithObjects": true
        },
        "horar": {
            "list": [
                "Alpheratz",
                "Almaak",
                "Dubhe",
                "Castor",
                "Pollux",
                "Sirius",
                "Zuben Elgenubi",
                "Zuben Eschamali",
                "Sadalsuud",
                "Skat",
                "Capella",
                "Arcturus",
                "Seginus",
                "Princeps",
                "Diadem",
                "Algorab",
                "Rasalgethi",
                "Alphard",
                "Spica",
                "Vindemiatrix",
                "Rastaban",
                "Yed Prior",
                "Sinistra",
                "Unukalhai",
                "Schedar",
                "Canopus",
                "Foramen",
                "Diphda",
                "Baten Kaitos",
                "Nashira",
                "Deneb Algedi",
                "Oculus",
                "Bos",
                "Deneb Adige",
                "Vega",
                "Regulus",
                "Denebola",
                "Zosma",
                "Al Jabhah",
                "Procyon",
                "Hamal",
                "Sheratan",
                "Betelgeuse",
                "Rigel",
                "Bellatrix",
                "Alnilam",
                "Altair",
                "Deneb el Okab Australis",
                "Markab",
                "Algol",
                "Acubens",
                "Asellus Borealis",
                "Asellus Australis",
                "Alphecca",
                "Antares",
                "Acumen",
                "Ascella",
                "Manubrium",
                "Terebellium",
                "Facies",
                "Aldebaran",
                "El Nath",
                "Ain Taurus",
                "Al Hecka",
                "Alcyone",
                "Toliman",
                "Agena",
                "Labrum",
                "Achernar",
                "Phact",
                "Fomalhaut",
                "Aculeus",
                "Praesepe Cluster"
            ],
            "showWithObjects": true
        }
    },
    fixedGmt: {},
    showSynastryTransits: false,
    calendarType: '',
    "maps": {
        "natal": {
            "orbises": {
                "0": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 10
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 9
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 7
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 4
                    }
                ],
                "30": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "36": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "40": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "45": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1.5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "60": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 10
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 9
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 7
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 4
                    }
                ],
                "72": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "80": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "90": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 10
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 9
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 7
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 4
                    }
                ],
                "100": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "108": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "120": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 10
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 9
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 7
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 4
                    }
                ],
                "135": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "144": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "150": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 3
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "180": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 10
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 9
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 7
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 4
                    }
                ]
            },
            "orbiseCorrector": 0
        },
        "solars": {
            "orbises": {
                "0": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    }
                ],
                "30": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "36": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "40": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "45": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "60": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    }
                ],
                "72": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "80": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "90": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    }
                ],
                "100": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "108": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "120": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    }
                ],
                "135": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "144": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "150": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "180": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    }
                ]
            },
            "orbiseCorrector": 0
        },
        "synastry": {
            "orbises": {
                "0": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 10
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 9
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 7
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 4
                    }
                ],
                "30": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "36": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "40": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "45": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1.5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "60": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 10
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 9
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 7
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 4
                    }
                ],
                "72": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "80": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "90": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 10
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 9
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 7
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 4
                    }
                ],
                "100": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "108": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "120": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 10
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 9
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 7
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 4
                    }
                ],
                "135": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "144": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "150": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 3
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "180": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 10
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 9
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 7
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 5
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 4
                    }
                ]
            },
            "orbiseCorrector": -60
        },
        "transits": {
            "orbises": {
                "0": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    }
                ],
                "30": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "36": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "40": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "45": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "60": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    }
                ],
                "72": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "80": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "90": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    }
                ],
                "100": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "108": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "120": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    }
                ],
                "135": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "144": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "150": [
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    }
                ],
                "180": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    }
                ]
            },
            "orbiseCorrector": 0
        },
        "directions": {
            "orbises": {
                "0": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1.5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "30": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "36": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "40": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "45": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "60": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1.5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "72": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "80": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "90": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1.5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "100": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "108": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "120": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1.5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "135": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "144": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "150": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "180": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1.5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ]
            },
            "orbiseCorrector": 0
        },
        "progressions": {
            "orbises": {
                "0": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1.5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "30": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "36": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "40": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "45": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "60": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1.5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "72": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "80": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "90": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1.5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "100": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "108": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "120": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1.5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "135": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "144": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "150": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ],
                "180": [
                    {
                        "disabled": false,
                        "major": false,
                        "value": 2
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1.5
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    },
                    {
                        "disabled": true,
                        "major": false,
                        "value": 0
                    },
                    {
                        "disabled": false,
                        "major": false,
                        "value": 1
                    }
                ]
            },
            "orbiseCorrector": 0
        }
    }
};
export const defaultPersonalization = {
    "circle": {
        "scale": {
            "min": 0.5,
            "max": 3,
            "step": 0.05
        },
        "gap": 250,
        "radius": {
            "circle": 376,
            "houses": 1.16,
            "cusps": 1.1,
            "external": 1,
            "zodiacsExternal": 1,
            "zodiacsInternal": 0.91,
            "internal": 0.7,
            "internalHorar": 0.35,
            "zodiacsExternalExt": 0.86,
            "zodiacsInternalExt": 0.77,
            "internalExt": 0.55,
            "internalSoul": 0.1,
            "modifier": {
                "objects": 0.9,
                "zodiacs": 1,
                "objectsExt": 0.9
            }
        },
        "zodiacs": {
            "gap": 0,
            "iconSize": 0.05,
            "style": 3
        },
        "houses": {
            "width": 1.2,
            "length": 1
        },
        "objects": {
            "iconSize": 0.065,
            "pointSize": 0.0075,
            "strongSize": 0.006,
            "style": 2,
            "location": 0
        },
        "aspects": {
            "icon": 0.05,
            "width": 1.3
        },
        "colorThemes": {
            "maps": {
                "active": 1
            },
            "zodiacs": {
                "active": 1
            },
            "houses": {
                "active": 0
            },
            "objects": {
                "active": 0
            },
            "aspects": {
                "active": 0
            }
        }
    },
    "computedRadius": {
        external: 1,
        internal: 0.7,
        internalExt: 0.55,
        zodiacsExternal: 1,
        zodiacsExternalExt: 0.86,
        zodiacsInternal: 0.91,
        zodiacsInternalExt: 0.77
    }
};
